<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

    export default {
        name: 'App',
        created() {

        }
    }
</script>

<style lang="scss">
    @import "styles/reset";
    .el-breadcrumb__separator {
        color: #1992FB;
        font-weight: bold;
    }
    .el-breadcrumb__inner.is-link {
        color: #1992FB
    }
    #app {
        width: 100%;
        height: 100%
    }
</style>



// WEBPACK FOOTER //
// src/App.vue